import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { QuotesService } from '../../../core/data/services/quotes.service';
import { SwalService } from '../../../common/services/swal.service';
import { from, map } from 'rxjs';

/**
 * Guard to warn user that navigating to home will restart the quote process
 * if there is a current quote in progress. On confirm, clears the session.
 */
export const resetQuoteGuard: CanActivateFn = () => {
  const quotes = inject(QuotesService);
  const swal = inject(SwalService);
  inject(Router); // Not used currently, but available if redirect logic is needed.

  if (!quotes.currentQuote) {
    return true;
  }

  return from(
    swal.confirm(
      'Esto reiniciará el proceso de cotización en curso. ¿Deseas continuar?',
      'Reiniciar cotización'
    )
  ).pipe(
    map((result) => {
      if (result.isConfirmed) {
        quotes.clearCurrentQuote();
        return true;
      }
      return false;
    })
  );
};
